import { FunctionComponent as F } from "react";
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { MenuItem } from "@mui/material";
import { PopupState } from 'material-ui-popup-state/hooks'
import { useSelector } from 'react-redux';
import { IState } from "../../core/store/store";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { duplicateAsync } from "../../core/store/protocol/protocol.thunks";
import { useAppDispatch } from "../../core/store/hooks";
import { PROTOCOL } from "../../core/router/paths";
import { useNavigate } from "react-router-dom";


interface Props
{
  protocolId: number,
  popupState: PopupState
  showDuplicateWarningDialog: () => void
}

const DuplicateProtocol: F<Props> = (props: Props) =>
{
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();
  const user = useSelector((state: IState) => state.user);

  const handleClick = async() =>
  {
    props.popupState.close();

    if(!user.premium)
      return props.showDuplicateWarningDialog();

    const protocolId = await appDispatch(duplicateAsync(props.protocolId));

    navigate(PROTOCOL + "/" + protocolId);
  }

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>
        <FileCopyIcon fontSize='small'/>
      </ListItemIcon>
      <ListItemText primaryTypographyProps={{ variant: 'body2' }}>Duplicate</ListItemText>
    </MenuItem>);
}

export default DuplicateProtocol;

